
    export const TechStacks = [
        "WordPress",
        "Drupal",
        "Magento",
        "Shopify",
        "Laravel",
        "AWS",
        "QA",
        "HTML Email Development",
        "Design",
        "Frontend Development",
        "React Native",
        "Flutter",
        "Android/iOS",
        "MERN",
        "ReactJs",
        "NodeJs",
        "GohighLevel",
        "ChatGPT",
      ];

// export default TechStacks;